import React from 'react';
import cx from 'classnames';

import { ColorTokenProp } from '../../../theme/tokens/color';
import { getTextColorClass } from '../../../utils/colorTokenToTailwind';

import { NodeProps } from './shared';

interface ParagraphNodeProps extends NodeProps {
  colour?: ColorTokenProp | string;
  plansTierStyling?: boolean;
  className?: string;
}

export function ParagraphNode({
  colour,
  children,
  plansTierStyling = false,
  className
}: ParagraphNodeProps) {
  const desktopFontSize = plansTierStyling
    ? 'desktop:text-base'
    : 'desktop:text-lg';

  return (
    <p
      className={cx(
        'whitespace-pre-wrap break-words text-base leading-[1.25rem]',
        desktopFontSize,
        'desktop:leading-[1.625rem]',
        getTextColorClass(colour),
        plansTierStyling ? '' : '[&:not(:last-child)]:mb-6',
        className
      )}
    >
      {children}
    </p>
  );
}
